import {
  InsuranceJourneyState,
  JourneyState,
  PaymentMethod,
  QuoteStatus
} from '../components/common/CommonTypes';
import { SelectInputHelper } from '../components/common/SelectInput/SelectInput';
import { blankVehicle } from '../components/testData/journeyHelper';

export const PageAbsolutePath = {
  Renewals: {
    Landing: '/:countrycode?/renewal',
    PersonalDetails: '/:countrycode?/renewal/renewalsjourney/personaldetails',
    VehicleDetails: '/:countrycode?/renewal/renewalsjourney/vehicledetails',
    Quote: '/:countrycode?/renewal/renewalsjourney/quote',
    Summary: '/:countrycode?/renewal/renewalsjourney/summary',
    DirectDebit: '/:countrycode?/renewal/renewalsjourney/directdebit',
    SinglePayment: '/:countrycode?/renewal/renewalsjourney/singlepayment',
    Confirmation: '/:countrycode?/renewal/renewalsjourney/confirmation',
    FailedRegistration:
      '/:countrycode?/renewal/renewalsjourney/failedregistration',
    LateRenewalAcceptance:
      '/:countrycode?/renewal/renewalsjourney/laterenewalacceptance',
    PaymentAssistSuccess:
      '/:countrycode?/renewal/renewalsjourney/paymentassist/success',
    PaymentAssistFailure:
      '/:countrycode?/renewal/renewalsjourney/paymentassist/failure'
  },
  Customer: {
    Landing: '/:countryCode?/customer',
    VehicleDetails: '/:countrycode?/customer/customerjourney/vehicledetails',
    Products: '/:countrycode?/customer/customerjourney/products',
    CreatePlan: '/:countrycode?/customer/customerjourney/createplan',
    PersonalDetails: '/:countrycode?/customer/customerjourney/personaldetails',
    Summary: '/:countrycode?/customer/customerjourney/summary',
    DirectDebit: '/:countrycode?/customer/customerjourney/directdebit',
    SinglePayment: '/:countrycode?/customer/customerjourney/singlepayment',
    Confirmation: '/:countrycode?/customer/customerjourney/confirmation',
    FailedRegistration:
      '/:countrycode?/customer/customerjourney/failedregistration',
    PaymentAssistSuccess:
      '/:countrycode?/customer/customerjourney/paymentassist/success',
    PaymentAssistFailure:
      '/:countrycode?/customer/customerjourney/paymentassist/failure'
  },
  Landing: '/:countrycode?',
  VehicleDetails: '/:countrycode?/dealerjourney/vehicledetails',
  Products: '/:countrycode?/dealerjourney/products',
  CreatePlan: '/:countrycode?/dealerjourney/createplan',
  PersonalDetails: '/:countrycode?/dealerjourney/personaldetails',
  Summary: '/:countrycode?/dealerjourney/summary',
  DirectDebit: '/:countrycode?/dealerjourney/directdebit',
  SinglePayment: '/:countrycode?/dealerjourney/singlepayment',
  Confirmation: '/:countrycode?/dealerjourney/confirmation',
  FailedRegistration: '/:countrycode?/dealerjourney/failedregistration',
  UnderMaintenance: '/:countrycode?/undermaintenance',
  PaymentAssistSuccess: '/:countrycode?/dealerjourney/paymentassist/success',
  PaymentAssistFailure: '/:countrycode?/dealerjourney/paymentassist/failure',
  Error: '/:countrycode?/errorpage',
  Insurance: {
    Landing: '/insurance',
    OldDealerLanding: '/dealer',
    DealerLandingPage: '/insurance/dealer',
    DealerLoginPage: '/insurance/dealer/login',
    DealersHomePage: '/insurance/dealers/home',
    DealersAdminPage: '/insurance/dealers/admin',
    DealersResources: '/insurance/dealers/resources',
    AboutYou: '/insurance/aboutyou',
    DrivingHistory: '/insurance/drivinghistory',
    VehicleDetails: '/insurance/vehicledetails',
    InsuranceCoverDetailsPage: '/insurance/insurancecoverdetails',
    AdditionalDriverDetailsPage: '/insurance/additionaldriverdetails',
    AddressDetailsPage: '/insurance/AddressDetailsPage',
    ConfirmationPage: '/insurance/ConfirmationDetails',
    Referral: '/insurance/referral',
    SiteMap: '/insurance/sitemap',
    MotorInsuranceClaim: '/insurance/motorinsuranceclaim',
    EligibilityAncillaryPage: '/insurance/eligibilityancillarypage',
    AlternateEligibility: '/insurance/alternateeligibility',
    OrderVerification: '/insurance/orderverification',
    AncillaryPage: '/insurance/ancillarypage',
    FairUseNoticePage: '/insurance/fairusenoticepage',
    TermsUseAncillaryPage: '/insurance/termsuseancillarypage',
    BusinessTermsAncillaryPage: '/insurance/businessancillarypage',
    TermsAndConditions: '/insurance/termsandconditions',
    CoverDetailsPage: '/insurance/coverdetailspage',
    ElectricVehiclePage: '/insurance/electricvehiclepage',
    ExcessReturnPolicyTermsConditions:
      '/insurance/ExcessReturnPolicyTermsConditions',
    FaqsPage: '/insurance/faqspage',
    RetrieveQuote: '/insurance/RetrieveQuote',
    ProofOfNcd: '/insurance/ProofOfNcd',
    RegisterExcessReturn: '/insurance/RegisterForExcessReturn',
    CustomerSelfRegistration: '/insurance/CustomerSelfRegistration',
    DriveAway: '/insurance/driveaway',
    PolicyDocuments: '/insurance/policydocuments',
    YourQuote: '/insurance/yourquote',
    OptionalCover: '/insurance/optionalcover',
    CheckYourDetails: '/insurance/checkyourdetails',
    PaymentPage: '/insurance/paymentpage',
    PolicyConfirmation: '/insurance/policyconfirmation',
    FailedRegistration: '/insurance/failedregistration',
    HelpPage: '/insurance/help',
    AboutTermsOfBusinessAndFairUsageNotice: '/insurance/termsofbusiness',
    ImportantNoticeInformation: '/insurance/importantnotice',
    SettingUpDirectDebit: '/insurance/settingupdirectdebit',
    UpdatePreferencesPage: '/insurance/updatepreferencespage',
    PostcodeConfirmationPage: '/insurance/postcodeconfirmation',
    AccidentAssistance: '/insurance/accidentAssistance',
    ServiceExcess: '/insurance/serviceExcessPage',
    ExcessConfirmation: '/insurance/excessconfirmation',
    MyAccount: '/insurance/myaccount',
    DealerReferral: '/insurance/dealerreferral'
  },
  InsuranceRedirect: {
    FairUseNotice: '/fairusenotice'
  }
} as const;

export const PageRelativePath = {
  PersonalDetails: '../personaldetails',
  VehicleDetails: '../vehicledetails',
  Quote: '../quote',
  Products: '../products',
  CreatePlan: '../createplan',
  Summary: '../summary',
  DirectDebit: '../directdebit',
  SinglePayment: '../singlepayment',
  PaymentAssistSuccess: '../paymentassist/success',
  PaymentAssistFailure: '../paymentassist/failure',
  Confirmation: '../confirmation',
  CustomerFailedRegistration: '../customerjourney/failedregistration', //as this is navigated from the manager it needs the journey specifying
  DealerFailedRegistration: '../dealerjourney/failedregistration', //as this is navigated from the manager it needs the journey specifying
  RenewalFailedRegistration: '../renewalsjourney/failedregistration', //as this is navigated from the manager it needs the journey specifying
  LateRenewalAcceptance: '../laterenewalacceptance'
} as const;

export const VehicleLookup = {
  RegistrationDate: 0,
  Types: 1,
  Makes: 2,
  Model: 3,
  Fueltype: 4,
  Enginesize: 5,
  Modeltrim: 6,
  Finished: 7
};

export const ProductTypes = {
  Alloy: 36,
  Cosmetic: 25,
  Gap: 26,
  RoadsideAssistance: 30,
  ServicePlan: 31,
  Tyre: 32,
  Warranty: 33
} as const;

export const RegistrationState = {
  Initial: 0,
  Registering: 1,
  Success: 2,
  Failed: 3,
  VoidingPayment: 4
} as const;

export const ProductChannel = {
  Customer: 2,
  DealerJourney: 3,
  OpenSite: 4,
  RenewalJourney: 5,
  Insurance: 6
} as const;

export const PaymentDay = {
  Default: '31',
  Empty: '0'
} as const;

export const Journey = {
  Initial: -1,
  DealerJourney: 1,
  Renewals: 2,
  CallCentre: 3,
  Customer: 4,
  Insurance: 5
} as const;

export enum VehicleIdType {
  Vrn = 1,
  Vin,
  Email
}

export const LateRenewalConditions = [
  'The vehicle for which this warranty is being purchased has no faults.',
  'If the vehicle is later found to have faults that were present at time of purchase the claim could be voided, and no payment made.',
  'I agree to provide documentation in respect of ownership and insurance if requested as part of any claims validation.',
  'I am not a director or majority shareholder in any motor trade business involved in the repair and maintenance or sale of motor vehicles.',
  'I am not using the vehicle for hire and reward purposes (for example as use as a taxi or delivery vehicle).',
  'The vehicle has been serviced in line with the manufacturer recommended schedule.'
];

export const LateRenewalCallCenterConditions = [
  'The vehicle does not have any pre-existing faults or pending claims.',
  'Customer is aware any faults that occurred before this policy started will not be covered under this policy. If the vehicle is later found to have faults that were present at the purchase of this policy the claim could be voided and no payment will be made.'
];

export const RenewalSourceSystem = {
  None: 0,
  ODIE: 1,
  VSC: 2,
  API: 3
} as const;

export const VehicleAPIErrorMessages = {
  VregError:
    "Sorry we couldn't find a vehicle matching that registration. Please try again or click 'Enter details manually' below to select your vehicle manually.",
  VinError:
    "Sorry we couldn't find a vehicle matching that VIN. Please try again or click 'Enter details manually' below to select your vehicle manually."
} as const;

export const QuoteAPIErrorMessages = {
  VregError:
    "Sorry we couldn't find a vehicle matching that registration. Please try again or click 'Enter details manually' below to select your vehicle manually.",
  VinError:
    'Sorry we could not find a vehicle matching that VIN. Please try again, enter the vehicle registration or enter the details manually.',
  EmailError:
    'Sorry we could not find a vehicle matching from that email address. Please try again, enter the vehicle registration or enter the details manually.'
} as const;

export const RenewalAPIErrorMessages = {
  VregError:
    "Sorry we couldn't find the full details of the vehicle matching that registration. Please contact our support team on 0344 573 8002.",
  RecordIdError:
    "Sorry we couldn't find the full details of vehicle matching the registration. Please enter the vehicle details manually."
} as const;

export const initialInsuranceJourneyState: InsuranceJourneyState = {
  tiaProductCode: '',
  quoteId: 0,
  policyNumber: '',
  quoteStatus: QuoteStatus.Partial,
  source: '',
  savingQuote: false,
  personalDetails: {
    title: SelectInputHelper.NullValue(),
    gender: '',
    firstName: '',
    lastName: '',
    email: '',
    maritalStatus: '',
    homePhone: '',
    mobilePhone: '',
    dateOfBirth: undefined,
    employmentStatus: '',
    industry: '',
    occupation: '',
    residentSinceBirth: false,
    residentSinceDate: undefined,
    ownHome: undefined,
    expiryMonth: ''
  },
  drivingHistoryDetails: {
    licenceType: '',
    yearsLicenceHeld: '',
    hasNonMotoringConvictions: undefined,
    hadDeclinedInsurance: undefined,
    noClaimsBonusYear: '',
    hadClaimAccidentLosses: undefined,
    claims: [],
    hadDrivingConvictions: undefined,
    drivingConvictions: [],
    hadMedicalConditionOrDisabilities: undefined,
    medicalConditions: [],
    ncdDiscount: undefined
  },
  vehicleInfo: {
    vrnKnown: undefined,
    manufacturer: '',
    model: '',
    fuelType: '',
    transmissionType: '',
    numberOfDoors: '',
    isItNewOrUsed: '',
    yearOfManufacture: '',
    hasTrackingDevice: undefined,
    trackingDevice: '',
    hasBeenModified: undefined,
    modifications: [],
    keysPickupDate: undefined,
    userVrn: '',
    vendor: '',
    dealer: '',
    carValue: '',
    vehicleSpecification: ''
  },
  coverDetails: {
    estimatedMileage: '',
    carUses: '',
    coverStartDate: undefined,
    coverStartTime: '',
    registeredVehicleKeeper: '',
    registeredVehicleOwner: '',
    paymentMode: '',
    estimatedBusinessMileage: ''
  },
  additionalDriverDetails: {
    whoWillDrive: SelectInputHelper.NullValue(),
    title: SelectInputHelper.NullValue(),
    firstName: '',
    maritalStatus: SelectInputHelper.NullValue(),
    dateOfBirth: undefined,
    gender: '',
    lastName: '',
    residentSinceBirth: false,
    residentSinceDate: undefined,
    relationWithPolicyHolder: SelectInputHelper.NullValue(),
    industry: '',
    occupation: '',
    licenceType: SelectInputHelper.NullValue(),
    yearsLicenceHeld: '',
    nonMotoringConvictions: undefined,
    declinedInsurance: undefined,
    hadClaimAccidentLosses: undefined,
    claims: [],
    hadDrivingConvictions: undefined,
    drivingConvictions: [],
    hadMedicalConditionOrDisabilities: undefined,
    medicalConditions: []
  },
  confirmationDetails: {
    iAgree: false,
    keepingYouInformed: '',
    nextYearInsurance: '',
    yourDocuments: '',
    marketingViaEmail: false,
    marketingViaPhone: false,
    marketingViaPost: false,
    marketingViaTextMessage: false
  },
  insuranceNavigationStatus: {
    aboutyou: false,
    drivingHistory: false,
    addressDetails: false,
    coverDetails: false,
    vehicleDetails: false,
    additonalDriverDetails: false,
    yourQuote: false,
    confirmation: false
  },
  addressDetails: {
    overnightParkedAddress: {
      addressList: undefined,
      addressLine1: undefined,
      addressLine2: undefined,
      townOrCity: undefined,
      region: undefined,
      country: undefined,
      postCode: undefined
    },
    isThisCorrespondenceAddress: undefined,
    correspondenceAddress: {
      addressList: undefined,
      addressLine1: undefined,
      addressLine2: undefined,
      townOrCity: undefined,
      region: undefined,
      country: undefined,
      postCode: undefined
    },
    locationVehicleParkedOvernight: '',
    numberOfCarsAtHousehold: ''
  },
  aboutTermsOfBusinessAndFairUseDetails: {
    readAndAgreeWithTerms: undefined,
    consentForDetailsToBePassed: undefined
  },
  importantNoticeInformationDetails: {
    readAndUnderstoodImportantInformationNotice: undefined
  },
  paymentDetails: {
    directDebitDetails: {
      accountHolderName: '',
      sortCode1: '',
      sortCode2: '',
      sortCode3: '',
      accountNumber: '',
      selectedPaymentDay: '',
      bankName: ''
    },
    cardPaymentDetails: {
      transactionId: ''
    },
    selectedPaymentMethod: PaymentMethod.annually
  },
  insuranceProducts: {
    quoteListItems: [],
    annualPayment: 0,
    arrangementFee: 0,
    excessCompulsoryPayment: 0,
    voluntaryExcess: SelectInputHelper.NullValue(),
    excessTotalPayment: 0,
    monthlyInstallment: 0,
    monthlyDeposit: 0,
    monthlyFirstInstallment: 0,
    monthlyInstallmentNumber: 0,
    monthlyAPR: 0,
    monthlyTotal: 0,
    monthlyFacilityFee: 0,
    maxRoundingDifference: 0,
    optionalProductList: [],
    policyDocumentId: 0,
    ipidStatementDocumentId: 0,
    importantInformationNoticeDocumentId: 0,
    showNCDDocument: false,
    showNCDPrice: false,
    ncdPrice: 0,
    invalid: false
  },
  staticData: [],
  dealerHomeOptions: {
    brandOptions: [],
    nonBrandOptions: [],
    showCustomerSelfRegistration: false,
    showDealerRegistration: false,
    includeDriveaway: true,
    includeExcessReturn: true
  },
  pageLoading: false
};

export const initialJourneyState: JourneyState = {
  vehicle: {
    vehicleDetails: blankVehicle,
    vehicleDeliveryDate: undefined,
    currentMileage: null,
    vehiclePurchasePrice: 0,
    salesId: '',
    dealerReference: '',
    deliveryDateEstimated: false
  },
  products: [],
  documents: [],
  personalDetail: {
    title: SelectInputHelper.NullValue(),
    firstName: '',
    surname: '',
    dateOfBirth: undefined,
    email: '',
    confirmEmail: '',
    phone: '',
    addressDetails: {
      addressLine1: '',
      addressLine2: '',
      townOrCity: '',
      region: '',
      country: '',
      postCode: ''
    }
  },
  directDebitDetails: {
    accountHolderName: '',
    sortCode1: null,
    sortCode2: null,
    sortCode3: null,
    accountNumber: null,
    selectedPaymentDay: PaymentDay.Default,
    bankName: ''
  },
  agreedTermsAndConditions: false,
  renewalMarketing: false,
  navigationStatus: {
    vehicle: false,
    products: false,
    personalDetails: false,
    checkout: false,
    confirmation: false,
    quote: false
  },
  singlePaymentDetails: {
    billingAddress: {
      addressLine1: '',
      addressLine2: '',
      townOrCity: '',
      region: '',
      country: '',
      postCode: ''
    }
  },
  registrationFailMsg: '',
  registrationState: RegistrationState.Initial,
  orderNumbers: [],
  expandedDocIds: [],
  foundExistingQuotes: false,
  dealerCode: '',
  token: '',
  policyStartDate: new Date(),
  isLateRenewal: false,
  promoCode: '',
  bankAuthorisationCode: '',
  quoteId: 0,
  hasQuoteExpired: false,
  quoteProducts: [],
  isExpiredMessageAcknowledged: false
};

export const functionNotImplemented = (): void => {
  console.error('onPolicyStartDateChange not implemented');
};

export const CaptchaMessages = {
  ValidationMessage: 'Captcha validation failed, try again.'
};

export const QuoteType = {
  Customer: 1,
  Dealer: 2
} as const;

export const InsuranceJourneyHelperText = {
  Pages: {
    AboutYou: {
      MobilePhone: `Should you take out a policy with us, we may need to
                      contact you about your policy or to remind you about your
                      renewal.`
    },
    AdditionalDriverDetails: {
      WhoWillDrive: `Adding a second driver may reduce your annual
       policy quote, assuming both drivers have a similar
       driving history.`,
      Medicalconditions: `The DVLA and insurers need to know about any medical conditions or disabilities that may affect your ability to drive, or notifiable driving licence conditions. Some insurers require information about the condition before providing a quote. The DVLA has a list of conditions that they need to be told about: https://www.gov.uk/health-conditions-and-driving`,
      InsuranceDeclined: `Insurance providers may cancel, decline or void a policy if anyone named on the policy misrepresented or failed to disclose important facts that are required to fulfil the policy terms and conditions.\n\n All insurance policies have standard terms and conditions. If you’ve ever had special terms imposed, you would have been advised by the insurance provider before the policy was taken out or renewed.`,
      NonMotoringConvictions: `A non-motoring conviction is a conviction that is not related to driving, for example breaking into a house or stealing a car would be classed as a non-motoring conviction (however excessively speeding in the stolen car would be classed as a motoring offence). After a specified period of time some criminal convictions are considered 'spent' and no longer need to be disclosed to your insurer. If you have a criminal conviction, you can use UNLOCK's online tool to calculate if it is spent (www.disclosurecalculator.org.uk).`
    },
    DrivingHistory: {
      Medicalconditions: `The DVLA and insurers need to know about any medical conditions or disabilities that may affect your ability to drive, or notifiable driving licence conditions. Some insurers require information about the condition before providing a quote. The DVLA has a list of conditions that they need to be told about: https://www.gov.uk/health-conditions-and-driving`,
      NonMotoringConvictions: `A non-motoring conviction is a conviction that is not related to driving, for example breaking into a house or stealing a car would be classed as a non-motoring conviction (however excessively speeding in the stolen car would be classed as a motoring offence). After a specified period of time some criminal convictions are considered 'spent' and no longer need to be disclosed to your insurer. If you have a criminal conviction, you can use UNLOCK's online tool to calculate if it is spent (www.disclosurecalculator.org.uk).`,
      InsuranceDeclined: `Insurance providers may cancel, decline or void a policy if anyone named on the policy misrepresented or failed to disclose important facts that are required to fulfil the policy terms and conditions.\n\n  All insurance policies have standard terms and conditions. If you’ve ever had special terms imposed, you would have been advised by the insurance provider before the policy was taken out or renewed.`,
      NoClaimDiscount: `NCD can only be used on one policy at a time. You will need to send us acceptable proof of your NCD within 21 days of your policy start date. Please see our Guide to NCD which outlines our NCD proof requirements.`,
      ProtectNcdDiscount:
        'Your NCD (No Claims Discount) years are valuable and provided you have 4 or more NCD years, you can protect them. You will need to provide proof of your NCD from your previous insurer. Protected NCD means that you may make a claim(s) in the year without your number of NCD years being reduced - please refer to your Policy Document for the ‘NCD Step Back Procedures’ applicable to your insurer.'
    },
    VehicleDetails: {
      VehicleSpecification: `Can't find your vehicle specification on the list? Please check the details are correct, for example, fuel type and number of doors. Alternatively, please call us on [Phone].`,
      Manufacturer: `Note: ONLY [Brand] vehicles receive free 7 Day Insurance. Non-[Brand] vehicles receive Get Me Home Cover which is shorter in duration. Check policy certificate once activated for details.`,
      WhatsItsValue: `This is the current cost of replacing your car with one of the same make, model and specification, taking into account its age, mileage and condition and not the price you paid for it. If you have a claim we will determine the market value of your vehicle at that time. The maximum we will pay if your vehicle is written off will not be greater than the amount you have told us.`,
      IsIt: `Approved Used is a [Brand] vehicle less than 18 months old, which has covered less than 18,000 miles.`,
      WhatsYearOfmanufacturer: `This is indicated by the vehicle's registration. For example AB15CDE, the 15 indicates it was made in 2015. For AB63CDE, subtract 50 from 63, which equals 13. This indicates the vehicle was made in 2013.`,
      TrackingDevice: `TRACKING DEVICE:\n\nApplicants for Free Driveaway Insurance with a vehicle valued at Â£75,000 or above require a vehicle tracking device. We accept Thatcham accredited Category S5 device – this replaces the previous Thatcham Category CAT 5 device. Please also note that the vehicle tracking device must be active before the cover start date as stated on the insurance certificate.`,
      HasItBeenModified: `A vehicle is considered modified if it has been changed in any way since it was first supplied by the vehicle manufacturer. This would include: Changes to the body work, suspension or brakes, cosmetic changes and changes to the engine management system or exhaust system. If you are unsure whether changes to the vehicle are classed as a modification, please call us.`
    },
    AddressDetails: {
      PostcodeOvernightParked: `Please provide the full UK postcode of the address at which the vehicle will usually be parked overnight and click the Find button.`,
      OvernightParked: `You confirm that your vehicle is kept overnight at this location.`,
      CarsInHousehold: `Some of our insurer panelists may offer a discount if you have access to other cars. You should only include the number of cars at your home. Please do not count motorbikes, vans and commercial vehicles.`
    },
    CoverDetails: {
      AnnualMileage: `Please enter the mileage you expect your car to cover in the next 12 months. It is important to estimate this amount as accurately as possible, as significant differences may affect your cover.`,
      CarUse: `Class of use: Social, domestic and pleasure (SD&P) purposes only \n\n Limitations: Use for any business purposes including commuting, commercial travelling, motor trade, carriage of goods or passengers for hire or reward, or for hiring, racing or speed testing, time trials, track days, rallies or 4 x 4 off road events, on the Nurburgring Nordschleife or any race track, racing circuit or prepared course.\n\n Class of use: Social, domestic and pleasure (SD&P) purposes including commuting Limitations: Use for any business purposes, commercial travelling, motor trade, hiring, carrying passengers for reward, racing or speed testing, time trials, track days, rallies or 4 x 4 off road events.\n\n Class of use: Social, domestic and pleasure (SD&P) purposes including commuting, and by the Policyholder only in person for his/her own or employers business Limitations: Use for motor trade, hiring, carrying passengers for reward, racing or speed testing, time trials, track days, rallies or 4 x 4 off road events.\n\n Class of use: Social, domestic and pleasure (SD&P) purposes including commuting, and by the Policyholder only in person for his/her own or employers business, and by the Policyholders spouse or civil partner in person for his/her own or employers business Limitations: Use for motor trade, hiring, carrying passengers for reward, racing or speed testing, time trials, track days, rallies or 4 x 4 off road events.\n\n Class of use: Social, domestic and pleasure (SD&P) purposes including commuting, and personal business use by the Policyholder and business use by all permitted named driver Limitations: Use for motor trade, hiring, carrying passengers for reward, racing or speed testing, time trials, track days, rallies or 4 x 4 off road events.`,
      CoverStartTime: `Please tell us when you'd like your cover to start.`,
      RegisteredKeeper: `The registered keeper should be the person who is actually using / keeping the vehicle and this is not necessarily the owner of the vehicle or the person who is paying for it. The registered keeper is the person named on the V5C (logbook) from the DVLA.`,
      RegisteredOwner: `The owner is the person (or company) who has paid for the car or was given it as a present.`
    }
  }
};

export enum SagePayAccount {
  Default = '',
  CallCentre = '/cc',
  Protex = '/protex'
}

export const InsuranceVehicleVendor = {
  FranchiseDealer: 'FR'
};

export const InsuranceVehicleNewUsed = {
  New: 'NEW',
  ApprovedUsed: 'APP_USED',
  Used: 'USED'
};

export const DefaultRadioOptions = ['Yes', 'No'];

export const ValidationConstants = {
  Insurance: {
    lastNameMinCharLimit: 2,
    firstNameCharLimit: 45,
    minAge: 17,
    maxAge: 90
  }
};

export const ValidationMessages = {
  InsuranceJourney: {
    firstnameRequiredMsg: 'First name is required',
    firstNameLimitError: `Too many characters. Max length ${ValidationConstants.Insurance.firstNameCharLimit}`,
    lastNameRequiredMsg: `Last name is required`,
    lastNameLimitError: `Last name should have minimum ${ValidationConstants.Insurance.lastNameMinCharLimit} characters`,
    invalidEmailMsg: `Email address is invalid`,
    emailRequiredMsg: `Email address is required`,
    ageOutOfRange: `Customer age must be between ${ValidationConstants.Insurance.minAge} to ${ValidationConstants.Insurance.maxAge}`,
    dobRequiredMsg: `Date of birth is required`,
    dobInvalidMsg: `Invalid date of birth`,
    postcodeInvalidMsg: `Postcode is invalid`,
    postcodeRequiredMsg: `Postcode is required`,
    errorInvalidName:
      'Please only use letters, spaces, hyphens and apostrophes.'
  }
};

export const InsuranceLoadingMessage =
  'Calculating your quote. This may take up to 60 seconds';

export const InsuranceSaveForLaterMessage = 'Just a moment.';

export const InsuranceRetrievingMessage =
  'Retrieving your quote. This may take up to 60 seconds';
